import {
  SLA_PROFILE_LIST, SLA_PROFILE_LIST_SUCCESS, SLA_PROFILE_LIST_FAILURE,
  SLA_PROFILE_DATA, SLA_PROFILE_DATA_SUCCESS, SLA_PROFILE_DATA_FAILURE,
  SLA_PROFILE_CREATE, SLA_PROFILE_CREATE_SUCCESS, SLA_PROFILE_CREATE_FAILURE,
  SLA_PROFILE_UPDATE, SLA_PROFILE_UPDATE_SUCCESS, SLA_PROFILE_UPDATE_FAILURE,
  SLA_PROFILE_DELETE, SLA_PROFILE_DELETE_SUCCESS, SLA_PROFILE_DELETE_FAILURE,
  SLA_METRIC_CREATE, SLA_METRIC_CREATE_SUCCESS, SLA_METRIC_CREATE_FAILURE,
  SLA_METRIC_UPDATE, SLA_METRIC_UPDATE_SUCCESS, SLA_METRIC_UPDATE_FAILURE,
  SLA_METRIC_DELETE, SLA_METRIC_DELETE_SUCCESS, SLA_METRIC_DELETE_FAILURE,
  CUSTOMER_SLA_LIST, CUSTOMER_SLA_LIST_SUCCESS, CUSTOMER_SLA_LIST_FAILURE,
  CUSTOMER_SLA_ACTIVE, CUSTOMER_SLA_ACTIVE_SUCCESS, CUSTOMER_SLA_ACTIVE_FAILURE,
  CUSTOMER_SLA_ASSIGN, CUSTOMER_SLA_ASSIGN_SUCCESS, CUSTOMER_SLA_ASSIGN_FAILURE,
  CUSTOMER_SLA_DELETE, CUSTOMER_SLA_DELETE_SUCCESS, CUSTOMER_SLA_DELETE_FAILURE,
} from "./actionType";

export const slaProfileList = (data) => ({ type: SLA_PROFILE_LIST, payload: data });
export const slaProfileListSuccess = (data) => ({ type: SLA_PROFILE_LIST_SUCCESS, payload: data });
export const slaProfileListFailure = (error) => ({ type: SLA_PROFILE_LIST_FAILURE, payload: error });

export const slaProfileData = (data) => ({ type: SLA_PROFILE_DATA, payload: data });
export const slaProfileDataSuccess = (data) => ({ type: SLA_PROFILE_DATA_SUCCESS, payload: data });
export const slaProfileDataFailure = (error) => ({ type: SLA_PROFILE_DATA_FAILURE, payload: error });

export const slaProfileCreate = (data) => ({ type: SLA_PROFILE_CREATE, payload: data });
export const slaProfileCreateSuccess = (data) => ({ type: SLA_PROFILE_CREATE_SUCCESS, payload: data });
export const slaProfileCreateFailure = (error) => ({ type: SLA_PROFILE_CREATE_FAILURE, payload: error });

export const slaProfileUpdate = (data) => ({ type: SLA_PROFILE_UPDATE, payload: data });
export const slaProfileUpdateSuccess = (data) => ({ type: SLA_PROFILE_UPDATE_SUCCESS, payload: data });
export const slaProfileUpdateFailure = (error) => ({ type: SLA_PROFILE_UPDATE_FAILURE, payload: error });

export const slaProfileDelete = (data) => ({ type: SLA_PROFILE_DELETE, payload: data });
export const slaProfileDeleteSuccess = (data) => ({ type: SLA_PROFILE_DELETE_SUCCESS, payload: data });
export const slaProfileDeleteFailure = (error) => ({ type: SLA_PROFILE_DELETE_FAILURE, payload: error });

export const slaMetricCreate = (data) => ({ type: SLA_METRIC_CREATE, payload: data });
export const slaMetricCreateSuccess = (data) => ({ type: SLA_METRIC_CREATE_SUCCESS, payload: data });
export const slaMetricCreateFailure = (error) => ({ type: SLA_METRIC_CREATE_FAILURE, payload: error });

export const slaMetricUpdate = (data) => ({ type: SLA_METRIC_UPDATE, payload: data });
export const slaMetricUpdateSuccess = (data) => ({ type: SLA_METRIC_UPDATE_SUCCESS, payload: data });
export const slaMetricUpdateFailure = (error) => ({ type: SLA_METRIC_UPDATE_FAILURE, payload: error });

export const slaMetricDelete = (data) => ({ type: SLA_METRIC_DELETE, payload: data });
export const slaMetricDeleteSuccess = (data) => ({ type: SLA_METRIC_DELETE_SUCCESS, payload: data });
export const slaMetricDeleteFailure = (error) => ({ type: SLA_METRIC_DELETE_FAILURE, payload: error });

export const customerSlaList = (data) => ({ type: CUSTOMER_SLA_LIST, payload: data });
export const customerSlaListSuccess = (data) => ({ type: CUSTOMER_SLA_LIST_SUCCESS, payload: data });
export const customerSlaListFailure = (error) => ({ type: CUSTOMER_SLA_LIST_FAILURE, payload: error });

export const customerSlaActive = (data) => ({ type: CUSTOMER_SLA_ACTIVE, payload: data });
export const customerSlaActiveSuccess = (data) => ({ type: CUSTOMER_SLA_ACTIVE_SUCCESS, payload: data });
export const customerSlaActiveFailure = (error) => ({ type: CUSTOMER_SLA_ACTIVE_FAILURE, payload: error });

export const customerSlaAssign = (data) => ({ type: CUSTOMER_SLA_ASSIGN, payload: data });
export const customerSlaAssignSuccess = (data) => ({ type: CUSTOMER_SLA_ASSIGN_SUCCESS, payload: data });
export const customerSlaAssignFailure = (error) => ({ type: CUSTOMER_SLA_ASSIGN_FAILURE, payload: error });

export const customerSlaDelete = (data) => ({ type: CUSTOMER_SLA_DELETE, payload: data });
export const customerSlaDeleteSuccess = (data) => ({ type: CUSTOMER_SLA_DELETE_SUCCESS, payload: data });
export const customerSlaDeleteFailure = (error) => ({ type: CUSTOMER_SLA_DELETE_FAILURE, payload: error });
